export const fetchSpotify = (state) => state?.spotify;
